{
  "companyGroups": {
    "header": "Organisations",
    "showOrganisations": "Show organisations →",
    "yourOrganisation": "Your organisation",
    "uploadLogo": "Upload company logo",
    "replaceLogo": "Replace company logo",
    "editName": "Edit organisation name",
    "create": {
      "button": "New organisation",
      "title": "New organisation",
      "nameLabel": "Organisation name",
      "parentLabel": "Parent organisation",
      "superadminTitle": "First superadmin",
      "superadminDescription": "Invite the user who will administer the new organisation. They will receive an invitation email.",
      "ownEmailWarning": "This is your own email address. An email address can only belong to one organisation — using it here will lock you out of your account."
    }
  }
}
